<script lang="ts">
  import { navigating, page } from '$app/stores';

  export let href: string;
  export let className = '';
  export let excludedQueryParams: string[] | null = null;

  $: [path, queryString] = href.split('?');
  $: queryParams = queryString ? new URLSearchParams(queryString) : null;
  $: active = isActive(path, queryParams, $page.url);

  // Sometimes the page store does not update properly/on time, appears to be due
  // to a timing issue. Subscribers are notified before the page store has actually
  // been updated.
  navigating.subscribe((navigating) => {
    if (!navigating) return;
    active = isActive(path, queryParams, navigating.to?.url);
  });

  function isActive(
    path: string | undefined,
    queryParams: URLSearchParams | null,
    url: URL | undefined
  ) {
    let isActive = path === url?.pathname;

    const pageQueryParams = url?.searchParams;

    if (excludedQueryParams) {
      excludedQueryParams.forEach((param) => {
        isActive = isActive && !pageQueryParams?.has(param);
      });
    }

    if (queryParams) {
      queryParams.forEach((value, key) => {
        isActive = isActive && pageQueryParams?.get(key) === value;
      });
    }

    return isActive;
  }
</script>

<a {href} class={className} class:active>
  <slot />
</a>
